// GSAP Animations
document.addEventListener("DOMContentLoaded", (event) => {
  if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    // Hero Parallax
    gsap.utils.toArray(".section-parallax .parallax-content").forEach((section) => {
      const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
      gsap.fromTo(section,
        { 
          y: 0
        },
        { 
          scrollTrigger: {
            trigger: section.parentElement,
            start: "top top",
            end: "bottom top",
            scrub: 0.5
          },
          y: heightDiff,
          ease: "none"
        }
      );
    });

    // Text Image Parallax
    gsap.utils.toArray(".parallax-image").forEach((section) => {
      const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
      gsap.fromTo(section,
        { 
          y: -heightDiff
        },
        { 
          scrollTrigger: {
            trigger: section.parentElement,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          },
          y: heightDiff,
          ease: "none"
        }
      );
    });

    // Cloud Parallax
    const clouds = document.querySelectorAll('.story-cloud');
    clouds.forEach((cloud, index) => {
      const speed = 0.8 + index * 0.3;
      gsap.fromTo(cloud,
        { y: 0 },
        {
          y: -100 * speed,
          ease: "none",
          scrollTrigger: {
            trigger: cloud,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    });

    // Reusable text split animation
    function animateText(element, delay = 0) {
      if (element) {
        gsap.set(element, { visibility: "visible" });
        const split = new SplitText(element, {
          type: "words",
          position: "relative"
        });
        
        gsap.to(element, { opacity: 1, duration: 0 });
        gsap.from(split.words, {
          duration: 0.8,
          opacity: 0,
          y: 30,
          rotationX: -20,
          transformOrigin: "0% 50% -50",
          stagger: 0.08,
          ease: "back.out(1)",
          delay: delay,
          scrollTrigger: {
            trigger: element,
            start: "top 90%",
            toggleActions: "play none none none"
          }
        });
      }
    }

    // Animate all split text elements
    document.querySelectorAll('.split-text').forEach((element, index) => {
      animateText(element, index * 0.15);
    });

    // CTA Slider Animation
    const ctaSlider = document.querySelector('.cta-slider');
    if (ctaSlider) {
      gsap.fromTo(ctaSlider,
        { x: '100px' },
        {
          x: '0%',
          duration: 1.5,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: ctaSlider,
            start: 'top 80%',
            end: 'bottom top',
            toggleActions: 'play none none none',
            scrub: true
          }
        }
      );
    }
  }
});

const swiper = new Swiper('.swiper', {
  loop: true,
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1.5,
    }
  },
});

// Initialize topbar slider
const topbarSwiper = new Swiper('.topbar-slider', {
  loop: true,
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  allowTouchMove: true,
  speed: 800,
  effect: 'slide'
});

function addProductToCart(variantID, title, quantity) {

let formData = {
  'items': [{
   'id': variantID,
   'quantity': 1
   }]
 };
 fetch(window.Shopify.routes.root + 'cart/add.js', {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json'
   },
   body: JSON.stringify(formData)
 })
 .then(response => {
   notificationActive(title);
   return response.json();
   
 })
 .catch((error) => {
   console.error('Error:', error);
 });
 
}


const addToCart = document.querySelectorAll('.add-to-cart');
addToCart.forEach((btn) => {
  btn.addEventListener('click', function() {
    console.log('ADD TO CARD!!,')
    addProductToCart( btn.dataset.id, btn.dataset.title, 1)
        notification.classList.remove('hidden');
  });
})

function notificationActive(title) {
      const nTitle = document.querySelector('.notification .title');
      const nImage = document.querySelector('.notification .image');
      const nSize= document.querySelector('.notification .sizes');
      const nPrice = document.querySelector('.notification .price');
      const nCount = document.querySelector('.notification .count');
  console.log(nTitle)
      nTitle.innerText = title
}



 const menuToggleOpen = document.querySelector('.menu-toggle-open');
 const menuToggleOverlay = document.querySelector('.menu-toggle-overlay');
 const menuCloseOverlay = document.querySelector('.menu-close-menu');

if(menuToggleOpen) {
  menuToggleOpen.addEventListener('click', function() {
   menuToggleOverlay.classList.toggle('hidden');
  })
}
if(menuCloseOverlay) {
  menuCloseOverlay.addEventListener('click', function() {
   menuToggleOverlay.classList.add('hidden');
  })
}

document.addEventListener('DOMContentLoaded', function() {
  const navToggleButtons = document.querySelectorAll('.nav-toggle');
  const shopOpen = document.getElementById('shopOpen');
  const infoOpen = document.getElementById('infoOpen');
  const closeMenuButton = document.getElementById('closeMenuButton');

  navToggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = button.id;
      if (targetId === 'shop') {
        if (shopOpen.classList.contains('open')) {
          shopOpen.classList.remove('open');
          closeMenuButton.classList.add('hidden');
        } else {
          if (infoOpen.classList.contains('open')) {
            infoOpen.classList.remove('open');
            shopOpen.classList.add('open');
          } else {
            gsap.fromTo(shopOpen, { y: '-100%' }, { duration: 0.3, y: '0%', ease: 'power2.out', onComplete: () => shopOpen.classList.add('open') });
          }
          closeMenuButton.classList.remove('hidden');
        }
      } else if (targetId === 'info') {
        if (infoOpen.classList.contains('open')) {
          infoOpen.classList.remove('open');
          closeMenuButton.classList.add('hidden');
        } else {
          if (shopOpen.classList.contains('open')) {
            shopOpen.classList.remove('open');
            infoOpen.classList.add('open');
          } else {
            gsap.fromTo(infoOpen, { y: '-100%' }, { duration: 0.3, y: '0%', ease: 'power2.out', onComplete: () => infoOpen.classList.add('open') });
          }
          closeMenuButton.classList.remove('hidden');
        }
      }
    });
  });

  if (closeMenuButton) {
    closeMenuButton.addEventListener('click', function() {
      if (shopOpen.classList.contains('open')) {
        gsap.to(shopOpen, { duration: 0.3, y: '-100%', ease: 'power2.in', onComplete: () => shopOpen.classList.remove('open') });
      }
      if (infoOpen.classList.contains('open')) {
        gsap.to(infoOpen, { duration: 0.3, y: '-100%', ease: 'power2.in', onComplete: () => infoOpen.classList.remove('open') });
      }
      closeMenuButton.classList.add('hidden');
    });
  }
});

